import {normalize, schema, denormalize} from 'normalizr';

export function normalizeDatos(myData) {
    const banner = new schema.Entity('banners', {}, {idAttribute: "id"});

    const mySchema = {banners: [banner]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const banner = new schema.Entity('banners', {}, {idAttribute: "id"});

    const mySchema = banner;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const banner = new schema.Entity('banners', {}, {idAttribute: "id"});

    const mySchema = banner;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}


